export const connectedEmailIconColors = ['#61CEF7', '#BD94BC', '#50E8B1', '#E88D67', '#FAC748']